var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.175,
    height: 17.9,
    viewBox: "0 0 18.175 17.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1964",
    "data-name": "Trac\\xE9 1964",
    d: "M3.525,8.525c0-1.25.55-1.725,1.425-1.725s1.425.475,1.425,1.725v9.45c0,1.25-.55,1.725-1.425,1.725s-1.425-.475-1.425-1.725ZM.775,17.8c0,2.8,1.475,4.4,4.175,4.4s4.175-1.6,4.175-4.4V8.7c0-2.8-1.475-4.4-4.175-4.4S.775,5.9.775,8.7ZM16.2,9.775c0,1.4-.625,1.85-1.65,1.85H13.475v2.5H14.4c1.25,0,1.8.6,1.8,2.225v1.375c0,1.55-.55,1.975-1.425,1.975s-1.425-.475-1.425-1.725V16.35h-2.6V17.8c0,2.8,1.4,4.4,4.1,4.4s4.1-1.6,4.1-4.4V16.425c0-1.775-.55-3.05-1.925-3.65v-.05c1.325-.55,1.925-1.7,1.925-3.575V8.7c0-2.8-1.4-4.4-4.1-4.4s-4.1,1.6-4.1,4.4v.95h2.6V8.525c0-1.25.55-1.725,1.425-1.725s1.425.425,1.425,2Z",
    transform: "translate(-0.775 -4.3)",
    fill: "#755383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon-03.55036258f1efd2b13cea1517426fccce.svg";
export { ForwardRef as ReactComponent };